/*  flow */
import type { Fund, Funds } from './App'
// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (value === null || isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
})()

export const round10 = Math.round10

export const twoDec = (num: number): string => round10(num, -2).toFixed(2)
export const decimalCount = (num: number): number => {
  const converted = num.toString();
  if (converted.includes('.')) {
    return converted.split('.')[1].length;
  }
  return 0;
}

export const createId = (prefix: string) => `${prefix}-${Math.random()}`.split('.').join('-')

type Cmp = (a: Fund, b: Fund) => boolean

const merge = (a: Funds, aux: Funds, lo: number, mid: number, hi: number, cmp: Cmp) => {
 for (let k = lo; k <= hi; k++) aux[k] = a[k]
 let i = lo, j = mid + 1
 for (let k = lo; k <= hi; k++) {
  if (i > mid) a[k] = aux[j++]
  else if (j > hi) a[k] = aux[i++]
  else if (cmp(aux[j], aux[i])) a[k] = aux[j++]
  else a[k] = aux[i++]
 }
}

const sort = (a: Funds, aux: Funds, lo: number, hi: number, cmp: Cmp) => {
  if (hi <= lo) return
  const mid = parseInt(lo + (hi - lo) / 2, 10)
  sort(a, aux, lo, mid, cmp)
  sort(a, aux, mid + 1, hi, cmp)
  merge(a, aux, lo, mid, hi, cmp)
}

export const mergesort = (a: Funds, cmp: Cmp) => {
  const aux: Funds = []
  sort(a, aux, 0, a.length - 1, cmp)  
}

// copied from https://jsfiddle.net/s61x7c4e/ - discussion - https://stackoverflow.com/questions/17722497/scroll-smoothly-to-specific-element-on-page
export function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}

export function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  // If element is close to page's bottom then window will scroll only to some position above the element.
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start

  if (!diff) return

	// Bootstrap our animation - it will get called right before next frame shall be rendered.
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start
		// Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1)
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent)

    window.scrollTo(0, startingY + diff * percent)

		// Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}




// WEBPACK FOOTER //
// ./src/utils.js